import { render, staticRenderFns } from "./ShIconDialog.vue?vue&type=template&id=b88b6e16&scoped=true&"
import script from "./ShIconDialog.vue?vue&type=script&lang=js&"
export * from "./ShIconDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShIconDialog.vue?vue&type=style&index=0&id=b88b6e16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88b6e16",
  null
  
)

export default component.exports